import { Component } from '@angular/core';
import { Platform,NavController, NavParams } from 'ionic-angular';
import { ConfigProvider } from '../../providers/config/config';
import { AlertProvider } from '../../providers/alert/alert';
import { LoadingProvider } from '../../providers/loading/loading';
import { SharedDataProvider } from '../../providers/shared-data/shared-data';
import { Http } from '@angular/http';
import { ProductDetailPage } from '../product-detail/product-detail';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CompletePage } from '../complete-page/complete-page';
import 'rxjs/add/operator/timeout';
import { EmailComposer } from '@ionic-native/email-composer';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';
import { HomePage } from '../home/home';
import swal from 'sweetalert';

@Component({
  selector: 'complete-install',
  templateUrl: 'complete-install.html',
})
export class CompleteInstallPage {
  order: { [k: string]: any } = {};
  finance = {};
  serialNumber = "";
  postData = {order_id:''};
  myData = {order_id:'',image_id:'',image:''};
  postToCloudinary = {upload_preset:'normal',file:''};
  httpRunning = true;
	images = [
    {
      id:'0',
      src:this.sanitizer.bypassSecurityTrustStyle(`url(assets/imgs/150x200.png)`),
      title:'Sat Note',
      rawData:'',
      isImage:'',
      order_id:''
    },
    {
      id:'1',
      src:this.sanitizer.bypassSecurityTrustStyle(`url(assets/imgs/150x200.png)`),
      title:'Picture of Boiler',
      rawData:'',
      isImage:'',
      order_id:''
    },
    {
      id:'2',
      src:this.sanitizer.bypassSecurityTrustStyle(`url(assets/imgs/150x200.png)`),
      title:'Boiler Serial',
      rawData:'',
      isImage:'',
      order_id:''
    },
    {
      id:'3',
      src:this.sanitizer.bypassSecurityTrustStyle(`url(assets/imgs/150x200.png)`),
      title:'Condensdate Termination (optional)',
      rawData:'',
      isImage:'',
      order_id:''
    },
    {
      id:'4',
      src:this.sanitizer.bypassSecurityTrustStyle(`url(assets/imgs/150x200.png)`),
      title:'Flue Termination (optional)',
      rawData:'',
      isImage:'',
      order_id:''
    },
    {
      id:'5',
      src:this.sanitizer.bypassSecurityTrustStyle(`url(assets/imgs/150x200.png)`),
      title:'Filter (optional)',
      rawData:'',
      isImage:'',
      order_id:''
    },
];
  bgImage:any;



  constructor(
    private sanitizer: DomSanitizer,
    public navCtrl: NavController,
    public config: ConfigProvider,
    public navParams: NavParams,
    public http: Http,
    public platform: Platform,
    private camera: Camera,
    private barcodeScanner: BarcodeScanner,
		private emailComposer: EmailComposer,
    public translate: TranslateService,
    public shared: SharedDataProvider,
    public alert: AlertProvider,
    public loading: LoadingProvider) {
    this.order = this.navParams.get('data');

    //console.log(this.order);

  }


  uploadDoc(order,id){
    this.loading.autoHide(10000);
    const options: CameraOptions = {
      quality: 100,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      allowEdit: false,
      saveToPhotoAlbum: false,
			sourceType: 1,
      correctOrientation: true,
			targetHeight:2048,
			targetWidth:2048
    }

    this.platform.ready().then(() => {


      this.camera.getPicture(options).then((imageData) => {

        this.images[id].src = this.sanitizer.bypassSecurityTrustStyle('url(' + 'data:image/jpeg;base64,' + imageData+ ')');
        this.images[id].rawData = 'base64:image.png//' + imageData;
        this.images[id].order_id=order.orders_id;
        this.images[id].isImage = 'true';
				this.loading.hide();
        //this.uploadImage(id,order.orders_id,'data:image/jpeg;base64,' + imageData)

      }, (err) => {
          this.images[id].src= '';

       });

    });

  }


  uploadImage(image_id,order_id,image)
  {
    this.loading.show();
    this.myData.order_id = order_id;
    this.myData.image_id = image_id;

    var data = this.myData;

    this.postToCloudinary.file = image;
    this.postToCloudinary.upload_preset = 'normal';
    //first put iage on cloudinary
		var clouddata = this.postToCloudinary;




  }
  scanBarcode(){
    console.log("Barcode Scan");
    this.barcodeScanner.scan().then(barcodeData => {
 console.log('Barcode data', barcodeData);
   this.serialNumber = barcodeData.text;
   this.order.serialNumber = barcodeData.text;
}).catch(err => {
    console.log('Error', err);
});

  }

  submitCompleteOrder(order){
    console.log("Install Complete");

    var data = this.order;
    this.http.post(this.config.url + 'setAsInstalled', data).map(res => res.json()).subscribe(data => {
        this.loading.hide();


      if (data.success == 1) {
        console.log("Success");
        this.order.orders_status = "Installed";
        swal({title: "Great!",text: "Another job Done!",icon: "success"}).then((value) => {

          this.navCtrl.popToRoot()
        });

      }
      if (data.success == 0) { this.alert.show(data.message); }
    }, err => {
        this.alert.show("Something went wrong. Try again later");


    });

  }


  submitCompleteOrderold(order){


		let email = {
		      to: 'documents@mail.paymonthlyboilershop.co.uk',
		      attachments: [
		        this.images[0].rawData,this.images[1].rawData,this.images[2].rawData,this.images[3].rawData,this.images[4].rawData,this.images[5].rawData
		      ],
		      subject:'' +order.orders_id +'' ,
		      body: 'Click send to submit your documents for review. Do not change subject of email',
		      isHtml: true
		    };

				this.emailComposer.open(email).then(() => {
														//Email opened
														this.resetImages();
														this.navCtrl.setRoot(CompletePage);
												});


  }


resetImages()
{
  this.images = [
    {
      id:'0',
      src:this.sanitizer.bypassSecurityTrustStyle(`url(assets/imgs/150x200.png)`),
      title:'Sat Note',
      rawData:'',
      isImage:'',
      order_id:''
    },
    {
      id:'1',
      src:this.sanitizer.bypassSecurityTrustStyle(`url(assets/imgs/150x200.png)`),
      title:'Picture of Boiler',
      rawData:'',
      isImage:'',
      order_id:''
    },
    {
      id:'2',
      src:this.sanitizer.bypassSecurityTrustStyle(`url(assets/imgs/150x200.png)`),
      title:'Boiler Serial',
      rawData:'',
      isImage:'',
      order_id:''
    },
    {
      id:'3',
      src:this.sanitizer.bypassSecurityTrustStyle(`url(assets/imgs/150x200.png)`),
      title:'Condensdate Termination (optional)',
      rawData:'',
      isImage:'',
      order_id:''
    },
    {
      id:'4',
      src:this.sanitizer.bypassSecurityTrustStyle(`url(assets/imgs/150x200.png)`),
      title:'Flue Termination (optional)',
      rawData:'',
      isImage:'',
      order_id:''
    },
    {
      id:'5',
      src:this.sanitizer.bypassSecurityTrustStyle(`url(assets/imgs/150x200.png)`),
      title:'Filter (optional)',
      rawData:'',
      isImage:'',
      order_id:''
    },
  ];

}

getInstallPics(){
  this.httpRunning = true;

  this.loading.show();
  var data: { [k: string]: any } = {};
  data.order_id = this.order.orders_id

  this.http.post(this.config.url + 'getInstallRecord', data).map(res => res.json()).subscribe(data => {
    this.loading.hide();
    console.log("INstallPics:",data);
    this.httpRunning = false;
    //$rootScope.address=response.data.data;
    if (data.success == 1) {
    if(typeof data.data[0] !== "undefined") {

        if(typeof data.data[0].image0 !== "undefined" && data.data[0].image0 !== null) {
            this.images[0].src = this.sanitizer.bypassSecurityTrustStyle('url(http://res.cloudinary.com/dzqruihmr/image/upload/t_media_lib_thumb/' + data.data[0].image0+ ')');
            this.images[0].isImage = 'true';
          }
          if(typeof data.data[0].image1 !== "undefined" && data.data[0].image1 !== null) {
              this.images[1].src = this.sanitizer.bypassSecurityTrustStyle('url(http://res.cloudinary.com/dzqruihmr/image/upload/t_media_lib_thumb/' + data.data[0].image1+ ')');
              this.images[1].isImage = 'true';
            }
            if(typeof data.data[0].image2 !== "undefined" && data.data[0].image2 !== null) {
                this.images[2].src = this.sanitizer.bypassSecurityTrustStyle('url(http://res.cloudinary.com/dzqruihmr/image/upload/t_media_lib_thumb/' + data.data[0].image2+ ')');
                this.images[2].isImage = 'true';
              }
              if(typeof data.data[0].image3 !== "undefined" && data.data[0].image3 !== null) {
                  this.images[3].src = this.sanitizer.bypassSecurityTrustStyle('url(http://res.cloudinary.com/dzqruihmr/image/upload/t_media_lib_thumb/' + data.data[0].image3+ ')');
                  this.images[3].isImage = 'true';
                }
                if(typeof data.data[0].image4 !== "undefined" && data.data[0].image4 !== null) {
                    this.images[4].src = this.sanitizer.bypassSecurityTrustStyle('url(http://res.cloudinary.com/dzqruihmr/image/upload/t_media_lib_thumb/' + data.data[0].image4+ ')');
                    this.images[4].isImage = 'true';
                  }
                  if(typeof data.data[0].image5 !== "undefined" && data.data[0].image5 !== null) {
                      this.images[5].src = this.sanitizer.bypassSecurityTrustStyle('url(http://res.cloudinary.com/dzqruihmr/image/upload/t_media_lib_thumb/' + data.data[0].image5+ ')');
                      this.images[5].isImage = 'true';
                    }
                    if(typeof data.data[0].image6 !== "undefined" && data.data[0].image6 !== null) {
                        this.images[6].src = this.sanitizer.bypassSecurityTrustStyle('url(http://res.cloudinary.com/dzqruihmr/image/upload/t_media_lib_thumb/' + data.data[0].image6+ ')');
                        this.images[6].isImage = 'true';
                      }
                      if(typeof data.data[0].image7 !== "undefined" && data.data[0].image7 !== null) {
                          this.images[7].src = this.sanitizer.bypassSecurityTrustStyle('url(http://res.cloudinary.com/dzqruihmr/image/upload/t_media_lib_thumb/' + data.data[0].image7+ ')');
                          this.images[7].isImage = 'true';
                        }
    }

    }
    // $scope.$broadcast('scroll.refreshComplete');
  },
    function (response) {
      this.loading.hide();
      this.alert.show("Server Error while Loading Orders");
      console.log(response);
    });
};

  ionViewDidLoad() {
    this.order = this.navParams.get('data');
   this.getInstallPics();

  }

}



// WEBPACK FOOTER //
// ./src/pages/complete-install/complete-install.ts